// @i18n-ignore-file
import { ExperimentDefinition } from '../experiments.types'

const EXPERIMENTS = {
  PDP_PARTNER_REC: {
    experimentName: 'pdp-partner-rec',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  PDP_REC_MODULES: {
    experimentName: 'pdp-rec-modules',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  PREORDER: {
    experimentName: 'preorder',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  MINI_PDP: {
    experimentName: 'mini-pdp',
    bucketNames: {
      control: 'control',
      testA: 'testA',
      testB: 'testB',
    },
  },
  PDP_COMPARISION_SECTION: {
    experimentName: 'pdp-comparison-section',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  REVIEW_HIGHLIGHTS_MOBILE: {
    experimentName: 'review-highlights-mobile',
    bucketNames: {
      show: 'show',
      control: 'control',
    },
  },
  REWARD_CREDIT_ON_CARTPAGE: {
    experimentName: 'reward-credit-on-cartpage',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
  CREDIT_TAGS_ON_PRODUCT_CARD: {
    experimentName: 'credit-tags-on-product-card',
    bucketNames: {
      control: 'control',
      show: 'show',
    },
  },
} satisfies Record<string, ExperimentDefinition>

export default EXPERIMENTS
